{
  "product-happy-hour-dialog": {
    "buttons": {
      "close": "Close"
    },
    "text": {
      "happy-hour": "Happy hour",
      "to": "to"
    }
  },
  "product-promotion-dialog": {
    "buttons": {
      "close": "Close"
    },
    "text": {
      "from-date-to-date": "from {{from}} to {{to}}"
    }
  },
  "salon-service-selection": {
    "buttons": {
      "select": "Select",
      "selected": "Selected"
    },
    "text": {
      "discount-details": "Discount details",
      "minutes": "minutes"
    }
  }
}
